import React from 'react';
import {Link} from 'react-router';
import {DeleteDialog} from 'modules/dialog';
import moment from 'moment';
import { connect } from 'react-redux';
import TextTruncate from 'react-text-truncate';
import {CheckPermission} from 'modules/login/CheckPermission';

class RowItemReception extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
    }
  }

  getLocal(diachi) {
    if(this.props.item.donSTCD.listNguoiDungDon.length) {
      let dungDon = [];
      if(diachi.diaChi) {
        dungDon.push(diachi.diaChi);
      }
      if(diachi.toThon) {
        dungDon.push(diachi.toThon);
      }
      if(diachi.phuongXaCongDan && diachi.phuongXaCongDan.ten) {
        dungDon.push(diachi.phuongXaCongDan.ten);
      }
      if(diachi.quanHuyenCongDan && diachi.quanHuyenCongDan.ten) {
        dungDon.push(diachi.quanHuyenCongDan.ten);
      }
      if(diachi.tinhThanhCongDan && diachi.tinhThanhCongDan.ten) {
        dungDon.push(diachi.tinhThanhCongDan.ten);
      }
      return dungDon.join(", ");
    }
  }

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.ngayTiepDan ? moment(this.props.item.ngayTiepDan).format('DD/MM/YYYY') : ''}</li>
            <li>{this.props.item.ngayTiepDan ? moment(this.props.item.ngayTiepDan).format('HH:mm') : ''}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li className="txt-bold">{this.props.item.donSTCD.listNguoiDungDon.length ? this.props.item.donSTCD.listNguoiDungDon[0].hoVaTen : ''}</li>
            <li>{this.getLocal(this.props.item.donSTCD.listNguoiDungDon[0])}</li>
            <li>{this.props.item.donSTCD.listNguoiDungDon.length ? this.props.item.donSTCD.listNguoiDungDon[0].soDienThoai : ''}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>
              { (this.props.item.tinhTrangXuLyTCDLanhDao === 'HOAN_THANH' && this.props.item.huongGiaiQuyetTCDLanhDao === 'CHO_GIAI_QUYET') || this.props.item.tinhTrangXuLyTCDLanhDao === 'DA_CO_BAO_CAO_KIEM_TRA_DE_XUAT' ?
                null : (
                  <Link className="txt-underline txt-regular" to={"/tiep-cong-dan/dinh-ky/chi-tiet/" +this.props.item.soTiepCongDanId}>
                    <TextTruncate
                      line={3}
                      truncateText="…"
                      text={this.props.item.donSTCD.noiDung}
                    />
                  </Link>
                )
              }
              { this.props.item.tinhTrangXuLyTCDLanhDao === 'HOAN_THANH' && this.props.item.huongGiaiQuyetTCDLanhDao === 'CHO_GIAI_QUYET' ?
                (
                  <Link className="txt-underline txt-regular" to={"/tiep-cong-dan/ket-qua-kiem-tra-de-xuat/hoan-thanh/" +this.props.item.soTiepCongDanId}>
                    <TextTruncate
                      line={3}
                      truncateText="…"
                      text={this.props.item.donSTCD.noiDung}
                    />
                  </Link>
                ) : null
              }
              { this.props.item.tinhTrangXuLyTCDLanhDao === 'DA_CO_BAO_CAO_KIEM_TRA_DE_XUAT' ?
                (
                  <Link className="txt-underline txt-regular" to={"/tiep-cong-dan/ket-qua-kiem-tra-de-xuat/" +this.props.item.soTiepCongDanId}>
                    <TextTruncate
                      line={3}
                      truncateText="…"
                      text={this.props.item.donSTCD.noiDung}
                    />
                  </Link>
                ) : null
              }
            </li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.donSTCD.loaiDonText || ''}</li>
            <li>{this.props.item.donSTCD.soNguoi} Người</li>
          </ul>
        </td>
        <td>{this.props.item.donSTCD.coQuanDaGiaiQuyetDonThu || ''}</td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.canBoTiepDanInfo.hoVaTen}</li>
          </ul>
        </td>
        <td>{this.props.item.huongGiaiQuyetTCDLanhDaoStr ? this.props.item.huongGiaiQuyetTCDLanhDaoStr : ''}</td>
        <td className={this.props.item.tinhTrangXuLyTCDLanhDao === 'DA_CO_BAO_CAO_KIEM_TRA_DE_XUAT' ? 'txt-warning' : ''}>{this.props.item.tinhTrangXuLyLanhDaoStr ? this.props.item.tinhTrangXuLyLanhDaoStr : ''}</td>
        <td>
          <div className="todo-wrap two-item">
            {
              CheckPermission('SOTIEPCONGDAN_SUA') && !this.props.item.hoanThanhTCDLanhDao && this.props.item.tinhTrangXuLyTCDLanhDao !== 'DA_CO_BAO_CAO_KIEM_TRA_DE_XUAT' && !this.props.item.donSTCD.dangGiaoKTDX ?
                <div className="wrap-link-todo">
                  <Link className="itt-edit" to={`/tiep-cong-dan/lanh-dao/dinh-ky-chinh-sua/${this.props.item.soTiepCongDanId}`}>Xử lý</Link>
                </div>
              : null
            }
            {
              CheckPermission('SOTIEPCONGDAN_SUA') && !this.props.item.hoanThanhTCDLanhDao && this.props.item.tinhTrangXuLyTCDLanhDao === 'DA_CO_BAO_CAO_KIEM_TRA_DE_XUAT' ?
                <div className="wrap-link-todo">
                  <Link className="itt-redirect" to={`/tiep-cong-dan/ket-qua-kiem-tra-de-xuat/${this.props.item.soTiepCongDanId}`}>Xử lý</Link>
                </div>
              : null
            }
            {
              CheckPermission('SOTIEPCONGDAN_XOA') && !this.props.item.hoanThanhTCDLanhDao && !this.props.item.donSTCD.dangGiaoKTDX ?
                <DeleteDialog
                  title= {'Xoá đơn thư'}
                  labelButton="Hủy"
                  content= {'Bạn chắc chắn muốn xoá đơn thư này?'}
                  redux={this.props.parent}
                  deleteId = {this.props.item.soTiepCongDanId}
                />
              : null
            }
          </div>
        </td>
      </tr>
    );
  }
}

let bindStateToProps = state => {
  return {
  }
}

export default connect(bindStateToProps)(RowItemReception);


// WEBPACK FOOTER //
// ./src/components/modules/reception-periodical/datatable/list/RowItemReception.jsx